export default {

  errors: {
    default: { ENG: 'Something went wrong', RUS: 'Что-то пошло не так' }
  }
}